import { SET_VALUES_EMAIL, CLEAR_VALUES_EMAIL } from '@constants/actionType'

const initialState = {
  general: null,
  comodines: [],
};

function emailState(state = initialState, actions) {
  switch (actions.type) {
    case SET_VALUES_EMAIL:
      return { ...state, ...actions.payload };
    case CLEAR_VALUES_EMAIL:
      return {
        general: null,
        comodines: [],
      };
    default:
      return state;
  }
}

export default emailState;
